import React, { Component } from 'react';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import Delete from '../images/deleteRecord.png';

class POForm extends Component {
  render() {
    return (
				<Card className="standard-form po-form">
					<Row className="po-header">
						<Col xs={6}>
              <h2 className="serviceDate">{this.props.title}</h2>
						</Col>
						<Col xs={6}>
              <Button
								className="poDelete miniBtnDelete"
                onClick={(e) => {
					e.preventDefault();
				  if (this.props.formChanged) {
					return window.alert('Please save changes before deleting new records');
				  }
                  if (window.confirm('Delete this Purchase Order?')) {
                    this.props.deleteSingleRecord(
											'purchase_order',
											this.props.recordID
                    );
                  }
                }}
              >
								<img src={Delete} className="deleteIcon"/>
              </Button>
            </Col>
          </Row>
          <CardBody>
            <Row>
              <Col xs={4}>{this.props.section1}</Col>
              <Col xs={4}>{this.props.section2}</Col>
              <Col xs={4}>{this.props.section3}</Col>
            </Row>
          </CardBody>
        </Card>
    );
  }
}

export default POForm;



// WEBPACK FOOTER //
// ./src/components/POForm.js